"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _getEmptyFieldValue = _interopRequireDefault(require("../../../helpers/getEmptyFieldValue.js"));
var _formWrapper = require("../../../reducers/formWrapper.js");
var _AssignmentPlans = _interopRequireDefault(require("./AssignmentPlans"));
var _AssignmentPlanSelections = _interopRequireDefault(require("./AssignmentPlanSelections"));
var _FieldMapper = _interopRequireDefault(require("./FieldMapper"));
var _TableField = _interopRequireDefault(require("./TableField"));
var _style = _interopRequireDefault(require("../style.css"));
var _JsonArray = _interopRequireDefault(require("./JsonArray"));
var _QuestOrgLimit = _interopRequireDefault(require("./QuestOrgLimit"));
var _DynamicForm;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd && window.cccisd.fortress;
var customFieldComponents = {
  assignmentPlans: _AssignmentPlans["default"],
  assignmentPlanSelections: _AssignmentPlanSelections["default"],
  table: _TableField["default"],
  jsonArray: _JsonArray["default"],
  questOrgLimit: _QuestOrgLimit["default"]
};
var DynamicValidation = function DynamicValidation(values, props) {
  return props.validateForm(values, props);
};
var DynamicForm = (_DynamicForm = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicForm, _React$Component);
  function DynamicForm() {
    var _this;
    _classCallCheck(this, DynamicForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DynamicForm, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      matchedUser: {}
    });
    /* /////////////////////////////////////////////////////////////////////////
    // REACT LIFECYCLE METHODS ////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (props) {
      _this.changeUserFields(props);
    });
    /* /////////////////////////////////////////////////////////////////////////
    // CLASS METHODS //////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */
    _defineProperty(_assertThisInitialized(_this), "changeUserFields", function (props) {
      if ((0, _isEqual2["default"])(_this.state.matchedUser, props.matchedUser)) {
        return;
      }
      var fieldTypes = props.fieldTypes;
      var hasMatchedUser = !(0, _isEmpty2["default"])(props.matchedUser);
      var _loop = function _loop() {
        var f = _Object$keys[_i];
        var field = props.fields[f];
        var fieldType = fieldTypes[f];

        // do this only if field is a column in nexus_users table and
        // doesn't depend on username value
        if (!field || !Fortress.settings.userFields.includes(f) || 'valueRequiredBy' in fieldTypes.username && fieldTypes.username.valueRequiredBy.includes(f)) {
          return 1; // continue
        }
        var newValue = hasMatchedUser ? props.matchedUser[f] : (0, _getEmptyFieldValue["default"])(fieldType);
        var requiredByFields = {};
        if (fieldType.valueRequiredBy) {
          fieldType.valueRequiredBy.forEach(function (requiredByField) {
            requiredByFields[requiredByField] = props.fields[requiredByField];
          });
        }
        props.changeAllFields(newValue, {
          field: field,
          fieldTypes: fieldTypes,
          operation: props.operation,
          requiredByFields: requiredByFields
        });
      };
      for (var _i = 0, _Object$keys = Object.keys(fieldTypes); _i < _Object$keys.length; _i++) {
        if (_loop()) continue;
      }
      _this.setState({
        matchedUser: props.matchedUser
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getFieldProps", function (field, fieldName) {
      var _this$props = _this.props,
        checkUserSettings = _this$props.checkUserSettings,
        fieldTypes = _this$props.fieldTypes,
        fields = _this$props.fields,
        isCheckingUser = _this$props.isCheckingUser,
        loadedData = _this$props.loadedData,
        matchedUser = _this$props.matchedUser,
        operation = _this$props.operation,
        row = _this$props.row;
      var fieldDef = fieldTypes[fieldName];
      // format object of required redux fields
      var requiredByFields = {};
      if (fieldDef.valueRequiredBy) {
        fieldDef.valueRequiredBy.forEach(function (requiredByField) {
          requiredByFields[requiredByField] = fields[requiredByField];
        });
      }
      var groupFieldHandle = checkUserSettings.groupField || 'group';
      var roleFieldHandle = checkUserSettings.roleField || 'role';
      var usernameFieldHandle = checkUserSettings.usernameField || 'username';
      var isDisabled = operation === 'create' && Fortress.settings.userFields.includes(fieldDef.reduxFieldHandle) && !(0, _isEmpty2["default"])(matchedUser);
      if (fieldDef.disableOnEdit && operation === 'edit' || fieldDef.disableOnCreate && operation === 'create') {
        isDisabled = true;
      }
      return {
        displaySettings: fieldDef.displaySettings,
        field: field,
        fieldTypes: fieldTypes,
        graphqlSettings: fieldDef.graphql || {},
        isCheckingUser: isCheckingUser,
        isDisabled: isDisabled,
        isUserCheckField: [usernameFieldHandle, roleFieldHandle, groupFieldHandle].includes(fieldDef.reduxFieldHandle),
        loadedData: loadedData,
        operation: operation,
        requiredByFields: requiredByFields,
        row: row,
        validationSettings: fieldDef.validationSettings
      };
    });
    _defineProperty(_assertThisInitialized(_this), "runCheckUser", function () {
      var _this$props2 = _this.props,
        checkUserSettings = _this$props2.checkUserSettings,
        fields = _this$props2.fields;
      var groupFieldHandle = checkUserSettings.groupField || 'group';
      var roleFieldHandle = checkUserSettings.roleField || 'role';
      var usernameFieldHandle = checkUserSettings.usernameField || 'username';
      var groupField = fields[groupFieldHandle];
      var roleField = fields[roleFieldHandle];
      var usernameField = fields[usernameFieldHandle];

      // If the username is valid, let's do a userCheck
      if (usernameField.valid) {
        var checkUserData = {
          username: usernameField.value
        };
        if (groupField && groupField.valid && groupField.value) {
          checkUserData.group = groupField.value;
        }
        if (roleField && roleField.valid && roleField.value) {
          checkUserData.role = roleField.value;
        }
        _this.props.checkUser(checkUserData);
      }
    });
    return _this;
  }
  _createClass(DynamicForm, [{
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        checkUserSettings = _this$props3.checkUserSettings,
        fieldTypes = _this$props3.fieldTypes,
        fields = _this$props3.fields,
        handleSubmit = _this$props3.handleSubmit,
        isCheckingUser = _this$props3.isCheckingUser,
        shouldCheckUser = _this$props3.shouldCheckUser,
        userAvailable = _this$props3.userAvailable;
      var groupFieldHandle = checkUserSettings.groupField || 'group';
      var roleFieldHandle = checkUserSettings.roleField || 'role';
      var groupExists = fields[groupFieldHandle] && fieldTypes[groupFieldHandle].displaySettings.renderAs !== 'hidden';
      var roleExists = fields[roleFieldHandle] && fieldTypes[roleFieldHandle].displaySettings.renderAs !== 'hidden';
      var btnStatus = 'btn-primary';
      var renderUserCheckMessage = '';

      // Report on whether the username is available once we've checked
      var isDisabled = isCheckingUser;
      if (this.props.hasCheckedUser && !isCheckingUser) {
        if (userAvailable) {
          renderUserCheckMessage = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].usernameValid
          }, "Username available");
        } else {
          btnStatus = 'btn-danger';
          isDisabled = true;
          renderUserCheckMessage = /*#__PURE__*/_react["default"].createElement("div", {
            className: _style["default"].usernameNotValid
          }, "Username not available. Try changing your username".concat(roleExists || groupExists ? ',' : '.').concat(roleExists ? ' role' : '').concat(groupExists ? ' group' : '').concat(roleExists || groupExists ? ' combination.' : ''));
        }
      }
      return /*#__PURE__*/_react["default"].createElement("div", null, renderUserCheckMessage, /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, Object.keys(fields).map(function (fieldName) {
        var field = fields[fieldName];
        var fieldDef = fieldTypes[fieldName];
        var emptyValue = '';
        if (fieldDef.handle !== 'formHandle') {
          emptyValue = (0, _getEmptyFieldValue["default"])(fieldDef);
        }
        var FieldComponent = customFieldComponents[fieldDef.displaySettings.renderAs] || _FieldMapper["default"];
        return /*#__PURE__*/_react["default"].createElement(FieldComponent, _extends({
          key: fieldName,
          shouldCheckUser: shouldCheckUser,
          runCheckUser: _this2.runCheckUser,
          emptyValue: emptyValue
        }, _this2.getFieldProps(field, fieldName)));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'table',
          width: '100%',
          paddingTop: '10px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'inline-block',
          "float": 'right'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn ".concat(btnStatus),
        title: "Submit",
        onClick: handleSubmit,
        isDisabled: isDisabled
      })))));
    }
  }]);
  return DynamicForm;
}(_react["default"].Component), _defineProperty(_DynamicForm, "propTypes", {
  /** The redux form fields object */
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  /** Each appdef field, keyed by handle */
  fieldTypes: _propTypes["default"].object,
  loadedData: _propTypes["default"].object,
  operation: _propTypes["default"].string,
  checkUser: _propTypes["default"].func,
  checkUserSettings: _propTypes["default"].object,
  hasCheckedUser: _propTypes["default"].bool,
  isCheckingUser: _propTypes["default"].bool,
  shouldCheckUser: _propTypes["default"].bool,
  userAvailable: _propTypes["default"].bool,
  validateForm: _propTypes["default"].func,
  formValid: _propTypes["default"].bool,
  row: _propTypes["default"].object
}), _DynamicForm);
var ReduxFormWrappedDynamicForm = (0, _reduxForm.reduxForm)({
  form: 'DynamicForm',
  validate: DynamicValidation,
  overwriteOnInitialValuesChange: false
})(DynamicForm);
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    formValid: state.appdefs.formWrapper.formValid,
    hasCheckedUser: state.appdefs.formWrapper.hasCheckedUser,
    isCheckingUser: state.appdefs.formWrapper.checkingUser,
    matchedUser: state.appdefs.formWrapper.matchedUser,
    userAvailable: state.appdefs.formWrapper.userAvailable
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields,
  checkUser: _formWrapper.checkUser,
  validateForm: _formWrapper.validate
})(ReduxFormWrappedDynamicForm);